import { Button, ButtonProps, CircularProgress } from '@mui/material'
import React, { InputHTMLAttributes } from 'react' // Import MUI Button component
import { FormikFormProps, useFormikContext } from 'formik' // Import formik hook

interface SubmitButtonWrapperProps
  extends InputHTMLAttributes<HTMLInputElement> {
  children: string
  loading?: boolean
}

const SubmitButtonWrapper: React.FC<ButtonProps & SubmitButtonWrapperProps> = ({
  children,
  loading,
  ...otherProps
}) => {
  const { submitForm } = useFormikContext<FormikFormProps>()

  const handleSubmit = () => {
    submitForm()
  }

  const configButton: ButtonProps = {
    ...otherProps,
    ...(otherProps.variant
      ? { variant: otherProps.variant }
      : { variant: 'contained' }),
    color: 'primary',
    disableElevation: true,
    onClick: handleSubmit,
  }

  return (
    <Button {...configButton}>
      {loading ? <CircularProgress color="inherit" size="24.5px" /> : children}
    </Button>
  )
}

export default SubmitButtonWrapper
